<template>
  <ValidationObserver
    class="vuetify-form"
    ref="obs"
    v-slot="{ invalid, passes }"
  >
    <v-row class="ma-0">
      <v-col cols="12" class="pa-0">
        <v-card flat class="about-box-shadow">
          <v-row class="ma-0">
            <v-col cols="12" class="pa-0">
              <VTextArea
                v-model="shortBio"
                :rules="{ required: true }"
                rows="3"
                placeholder="Add a short bio"
                auto-grow
                solo
              />
            </v-col>
          </v-row>
          <v-card-actions class="py-0 px-0">
            <v-spacer></v-spacer>
            <v-btn  class="btn-style d-flex justify-space-between" @click="hideBioComponent()" text color="red">Cancel</v-btn>
            <v-btn
              :disabled="invalid"
              class="btn-style"
              color="#096DD8"
              :dark="!invalid"
              @click="passes(updateBio)"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </ValidationObserver>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import { VTextArea } from "@/components/inputs";
import { ProfileService } from "@/services";

export default {
  name: "EditShortBio",
  components: {
    ValidationObserver,
    VTextArea
  },
  props: {
    shortBioInformation: String
  },
  data() {
    return {
      shortBioInfo: null,
      hideComponentEdit: null,
    };
  },
  computed: {
    shortBio: {
      get() {
        return this.shortBioInformation;
      },
      set(newValue) {
        this.shortBioInfo = newValue;
      }
    }
  },
  methods: {
    hideBioComponent() {
      this.$emit("hideBioComponent")
    },
    async updateBio() {
      this.$bus.$emit('isProfileLoading', true);
      const object = {
        bio: this.shortBioInfo
      };
      const response = await ProfileService.updateProfile(object);
      if (response) {
        // this.$emit("ShortBio", response.data.bio);
        this.$store.dispatch("user/setUser", response.data);
        this.$bus.$emit('isProfileLoading', false);
        this.hideBioComponent();
        this.$store.dispatch(
          "user/setSnack",
          "Short Bio Information Updated Successfully!"
        );
        this.$store.dispatch("user/setType", "info");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.v-list-item {
  .list-item {
    font-family: Palanquin;
    font-style: normal;
    font-size: 15px;
    line-height: 130%;
    color: #313131;
    letter-spacing: 0.05em;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
  }
  min-height: 30px;
}
.btn-style {
  text-transform: capitalize;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
</style>
